@if (vmData$ | async; as vmData) {
  <form [formGroup]="outreachForm" (submit)="onSubmit(vmData.templates, vmData.users)">
    <mat-card>
      <mat-card-content>
        <div class="flex flex-col gap-4">
          <div class="flex flex-row gap-2">
            <mat-form-field class="flex-1">
              <mat-label data-test-id="outreach-email-recipient-email-label">Recipient email</mat-label>
              <mat-select formControlName="receipientEmail" data-test-id="outreach-email-recipient-email-input">
                @for (email of expertEmails; track email) {
                  <mat-option data-test-id="outreach-email-recipient-email-option" [value]="email.address">
                    {{ email.address }}
                    @if (email.isPrimary) {
                      <span class="text-dim">(Primary)</span>
                    }
                  </mat-option>
                }
              </mat-select>
              <mat-error data-test-id="outreach-email-recipient-email-error">Required</mat-error>
            </mat-form-field>
            <mat-form-field class="flex-1">
              <mat-label data-test-id="outreach-email-sender-label">Sender</mat-label>
              <mat-select formControlName="senderUserId" data-test-id="outreach-email-sender-input">
                @for (user of vmData.users; track user) {
                  <mat-option data-test-id="outreach-email-sender-option" [value]="user.user_id">
                    {{ user.first_name }} {{ user.last_name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <app-outreach-email-content-form [templates]="vmData.templates"></app-outreach-email-content-form>
          <div class="flex flex-1 justify-end gap-4">
            @if (showCancel) {
              <button mat-button type="button" (click)="cancelled.emit()">Cancel</button>
            }
            <button
              matButton="filled"
              color="primary"
              type="submit"
              data-test-id="outreach-email-send-email-button"
              [disabled]="isLoading"
            >
              Send email
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
} @else {
  <div class="flex flex-col items-center justify-center gap-4">
    <app-spinner size="lg" />
  </div>
}
